import { render, staticRenderFns } from "./ProcessModifyBasicData.vue?vue&type=template&id=52ea33cf&scoped=true"
import script from "./ProcessModifyBasicData.vue?vue&type=script&lang=js"
export * from "./ProcessModifyBasicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea33cf",
  null
  
)

export default component.exports